module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAARdJREFUOE+tk9FRg0AQhr81vEsHHiN5jx1Qgh0kdhArcOwgViBWoB0kHRifwwxXAr6j69wFzIGEF7wnBu7/9t9/F2HikYl6POCAyQReQeIxoKKPEWy+YXkBLwm28oCCpAJdp9h8DFBi4hq2giwU3c+xN1JiFl/Ie0o52k4obop8zlAjR/uybQElxiRYGzo5I84S7L4DKDArkGfQPMXeOciY2H3vARJX+epYXfMZ3Lc9B7Z95dZhB9DksQMuG0gVTMb1nNUQz7Hujj9DGbhQA4i/58XuoR/4H0DTdwjxYme7H7h3cG6M7n0NmwjWbc+DgHaRBH24xj6NLVKBcYsWp9jb3wxOqyxvp/CGMYp+RLDqTOFffqYpkB8INIcgdtkAEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/update/selected.png
// module id = 1192
// module chunks = 41